export default "__VITE_ASSET__ChmCamRu__"